import React, { useState } from 'react'
import EditTodoForm from './EditTodoForm'
import Todo from './Todo'
import TodoForm from './TodoForm'
import { v4 as uuidv4 } from 'uuid';
uuidv4(); 
const TodoWrapper = () => {
    const [todos, setTodos] = useState([])

    const addTodo = todo => {
      setTodos([...todos, {id: uuidv4(), task: todo, completed: false, isEditing: false}])
    }
  
    const deleteTodo = id => {
      setTodos(todos.filter(todo => todo.id !== id))
    }
  
    const toggleComplete = id => {
      setTodos(todos.map(todo => todo.id === id ? {...todo, completed: !todo.completed} : todo))
    }
  
    const editTodo = id => {
      setTodos(todos.map(todo => todo.id === id ? {...todo, isEditing: !todo.isEditing} : todo))
    }
  
    const editTask = (task, id) => {
      setTodos(todos.map(todo => todo.id === id ? {...todo, task, isEditing: !todo.isEditing} : todo))
    }
    
    return (
      <div className='TodoWrapper'>
          <h1>Get Things Done!</h1>
          <TodoForm addTodo={addTodo} />
          {/* display todos */}
           {todos.map((todo, index) => (
            todo.isEditing ? (
              <EditTodoForm editTodo={editTask} task={todo} />
            ) : (
              <Todo key={index} task={todo} deleteTodo={deleteTodo} editTodo={editTodo} toggleComplete={toggleComplete} />
            )
             
           ))}
      </div>
    )
}

export default TodoWrapper